import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import FontIcon from 'material-ui/FontIcon';
import DialogModal from '../home/DialogModal';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { cyan900 } from 'material-ui/styles/colors';
import _ from 'lodash';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  catalog: PropTypes.object,
  products: PropTypes.array,
  catalogId: PropTypes.string.isRequired,
  error: PropTypes.any,
  query: PropTypes.object.isRequired,
  router: PropTypes.object,
};

class SortProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: !props.isAuthenticated,
      alertOpen: false,
      alertMessage: '',
      open: false,
      edited: false,
      dialogTitle: ' ',
      dialogMessage: ' ',
      dialogActionTitle: ' ',
      categoryFilter: 0,
      categories: [],
      products: [],
      catalog: {
        productSort: [],
        name: '',
        description: '',
      },
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.products[0].id > 0) {
      const productSort = [];
      const catalog = nextProps.catalog;
      const catalogItems = catalog.items;
      const catalogProducts = _.map(_.uniqBy(catalogItems, 'productId'), (item) => { // eslint-disable-line
        return item.productId;
      });
      const productCategories = _.map(_.uniqBy(this.props.products, 'parentCategory'), (product) => {
        return { id: product.parentCategory, name: product.name };
      });
      const categoryFilter = nextProps.categoryFilter || productCategories[0].id;
      // Get list of IDs for active catalog products
      const filteredProductsId = _.map(_(this.props.products)
        .keyBy('id')
        .at(catalogProducts)
        .pullAllBy([{ tenantDisabled: true }], 'tenantDisabled')
        .value(), 'id');
      // Remove recently disabled product ids from sort order
      catalog.productSort.forEach((id) => {
        if (_.indexOf(filteredProductsId, id) !== -1) {
          productSort.push(id);
        }
      });
      // Add newly enabled products && populate empty sort order
      filteredProductsId.forEach((id) => {
        if (_.indexOf(productSort, id) === -1) {
          productSort.push(id);
        }
      });
      // If no assigned sort order, set default else set saved sort order
      catalog.productSort = (_.size(this.props.catalog.productSort) < 1) ? filteredProductsId : productSort;
      // Order products array for display
      const products = _(this.props.products)
        .keyBy('id')
        .at(catalog.productSort)
        .orderBy(['parentCategory'], ['asc'])
        .value();
      // Create final sort order and assign
      catalog.productSort = _.map(products, 'id');
      this.setState(
        {
          catalog,
          products,
          productCategories,
          categoryFilter,
        });
    }
  }
  handleFilterChange(event, index, value) {
    const nextState = this.state;
    nextState.categoryFilter = value;
    this.setState(nextState);
  }
  handleCancel() {
    browserHistory.push(`/catalogs/${this.props.catalog.id}?page=1`);
  }
  handleSave() {
    this.setState({
      open: false,
      edited: false,
    });
    const catalog = this.state.catalog;
    delete catalog.items;
    this.props.onSave(catalog);
  }
  handleClose() {
    this.setState({
      open: false,
      edited: false,
    });
    browserHistory.push(`/catalogs/${this.props.catalog.id}?page=1`);
  }
  handleOpen() {
    const nextState = this.state;
    nextState.dialogTitle = 'Save Product Sort Changes';
    nextState.dialogMessage = 'Do you really want to save the changes?';
    nextState.dialogActionTitle = 'Save';
    nextState.open = true;
    this.setState({ nextState });
  }
  handleProductSortChange(productId, moveTo) {
    const catalog = _.clone(this.state.catalog);
    const index = _.indexOf(catalog.productSort, productId);
    const newIndex = (index === 0 && moveTo === -1) ? 0 : (index + moveTo);
    const nextStep = _.find(this.state.products, ['id', catalog.productSort[newIndex]]);
    if (nextStep && nextStep.parentCategory === this.state.categoryFilter) {
      catalog.productSort.splice(index, 1);
      catalog.productSort.splice(newIndex, 0, productId); // Replace item at index using native splice
      this.setState({
        catalog,
        edited: true,
      });
    }
  }
  renderProductProductsTableRows() {
    const iconStyles = {
      marginRight: 24,
    };
    if (!this.state.products) { return ''; }
    const categoryProducts = _.sortBy(_.filter(this.state.products, ['parentCategory', this.state.categoryFilter]), (product) => { // eslint-disable-line
      return _.indexOf(this.state.catalog.productSort, product.id);
    });
    return categoryProducts.map((product, i) =>
      <TableRow key={i}>
        <TableRowColumn style={{ width: '20%' }} key={i}>{product.name}</TableRowColumn>
        <TableRowColumn style={{ width: '20%' }} key={i}>{product.parentCategoryName}</TableRowColumn>
        <TableRowColumn style={{ width: '40%' }} key={i}>{product.description}</TableRowColumn>
        <TableRowColumn style={{ width: '20%' }} key={i}>
          <FontIcon
            className="fa fa-caret-up"
            style={iconStyles}
            onClick={() => this.handleProductSortChange(product.id, -1)}
          />
          <FontIcon
            className="fa fa-caret-down"
            style={iconStyles}
            onClick={() => this.handleProductSortChange(product.id, 1)}
          />
        </TableRowColumn>
      </TableRow>
    );
  }
  render() {
    // console.log("this.props: ",this.props)
    // console.log("CATEGORIES:" ,this.props.categories.results)
    const categorySelect = _.map(this.props.categories.results, c => <MenuItem value={c.id} key={c.id} primaryText={c.name} />);
    const tableStyles = {
      stripedRows: true,
      displaySelectAll: false,
      adjustForCheckbox: false,
      selectable: false,
      displayRowCheckbox: false,
    };
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
    };
    return (
      <div className="content">
        <DialogModal
          dialogOpen={this.state.open}
          dialogHandleClose={this.handleClose}
          dialogHandleSubmit={() => this.handleSave()}
          dialogTitle={this.state.dialogTitle}
          dialogMessage={this.state.dialogMessage}
          dialogActionTitle={this.state.dialogActionTitle}
        />
        <div className="float-right">
          <RaisedButton
            label="Cancel"
            style={{ marginRight: '10px' }}
            primary
            onClick={this.handleCancel}
          />
          <RaisedButton
            label="Save"
            primary
            style={{ marginRight: '10px' }}
            onClick={this.handleOpen}
          />
          <SelectField
            value=""
            onChange={(event, index, value) => this.handleFilterChange(event, index, value)}
            floatingLabelText="Filter by Category"
            style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px', float: 'right' }}
            name="categoryFilter"
            floatingLabelStyle={styles.floatingLabelStyle}
          >
            {categorySelect}
          </SelectField>
        </div>
        <Table selectable={false} wrapperStyle={{ overflow: 'inherit' }}>
          <TableHeader
            displaySelectAll={tableStyles.displaySelectAll}
            adjustForCheckbox={tableStyles.adjustForCheckbox}
          >
            <TableRow
              selectable={tableStyles.selectable}
            >
              <TableHeaderColumn style={{ width: '20%' }}>Name</TableHeaderColumn>
              <TableHeaderColumn style={{ width: '20%' }}>Parent Category</TableHeaderColumn>
              <TableHeaderColumn style={{ width: '40%' }}>Description</TableHeaderColumn>
              <TableHeaderColumn style={{ width: '20%' }}>Sort</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody
            stripedRows={tableStyles.stripedRows}
            displayRowCheckbox={tableStyles.displayRowCheckbox}
          >
            {this.renderProductProductsTableRows()}
          </TableBody>
        </Table>
      </div>
    );
  }
}

SortProducts.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

SortProducts.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    catalog: state.catalogs.catalog,
    products: state.products.results,
    catalogId: ownProps.params.id,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(SortProducts));



// WEBPACK FOOTER //
// ./src/components/catalogs/SortProducts.js